/*###########################################################################
// Components
//#########################################################################*/

/* Alpine Components
//------------------*/

import Alpine from 'alpinejs';
import sectionNavigator from "./_sectionNavigator";
import tabs from "./_tabs";
import { loginForm, forgotPasswordForm, setPasswordForm } from "./_loginForms";

Alpine.data('sectionNavigator', sectionNavigator)
Alpine.data('tabs', tabs)
Alpine.data('loginForm', loginForm)
Alpine.data('forgotPasswordForm', forgotPasswordForm)
Alpine.data('setPasswordForm', setPasswordForm)
Alpine.start();

/* Dynamic Components
//------------------*/

const dynamicComponents = () => {
	if (document.querySelector('.auto-text-size')) {
		import('./_autoTextSize')
	}

	if (document.querySelector('.accordion')) {
		import('./_accordions')
	}

	if (document.querySelector('.cardKitchen')) {
		import('./_cardKitchen')
	}

	if (document.querySelector('.copy-clipboard')) {
		import('./_copyClipboard')
	}

	if (document.querySelector('.borderAnimation')) {
		import('./_borderAnimation')
	}

	if (document.querySelector('.glightbox')) {
		import('./_glightbox')
	}

	if (document.querySelector('.h-screen, .md\\:h-screen')) {
		import('./_hScreenCalc')
	}

	if (document.querySelector('.modal')) {
		import('./_modals')
	}

	if (document.querySelector('.responsive-video')) {
		import('./_responsiveVideo')
	}

	if (document.querySelector('.shareArticle')) {
		import('./_shareArticle')
	}

	if (document.querySelector('.sliderCabinets')) {
		import('./_sliderCabinets')
	}

	if (document.querySelector('.sliderCta')) {
		import('./_sliderCta')
	}

	if (document.querySelector('.sliderGrid')) {
		import('./_sliderGrid')
	}

	if (document.querySelector('.sliderLogo')) {
		import('./_sliderLogo')
	}

	if (document.querySelector('.sliderProductCategories')) {
		import('./_sliderProductCategories')
	}

	if (document.querySelector('.sliderProductList')) {
		import('./_sliderProductList')
	}

	if (document.querySelector('.sliderWContent')) {
		import('./_sliderWContent')
	}
}

if (document.readyState === 'complete') {
	dynamicComponents()
} else {
	window.addEventListener('load', () => {
		dynamicComponents()
	})
}

window.addEventListener('page-change', () => {
	dynamicComponents()
})

/* Standard Components
//------------------*/

import './_animations'
import './_browserDetect'
import './_brochureForm'
import './_fullWidthImage'
import './_forms'
import './_header'
import './_lazyImagesScrollTrigger'
import './_tooltips'
import './_retailersMap'
import './_scriptHandling'
import './_scrollToSection'
import './_sprig'
import './_kitchenVisualiserTracking'

// Inside a modal so needs explicit load
//
import './_sliderHandle'
